import { Config } from './Config';
export class ConfigManager  {
	env!: string;
	props: Record<string, string> = {};
	
	getConfig(envKey: string): string {
		return this.props[envKey];
	}

	getEnv(): string {
		return this.env;
	}

	constructor(config?: Config) {
		if (config) {
			this.env = config.env;
			this.props = config.props;
		}		
	}
}